import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from '../../../environments/environment';

import { OrdenMantenimiento, OrdenMantenimientoCreate, OrdenMantenimientoUpdate, OrdenMantenimientoActividad, OrdenMantenimientoActividadCreate } from '../model/orden-mantenimiento.model';


interface ApiResponse<T> {
  codigo: number;
  mensaje: string;
  data: T;
}

@Injectable({
  providedIn: 'root'
})
export class OrdenMantenimientoService {

  private apiUrl =
    `${environment.apiUrl}/api/ordenes-mantenimiento`;

 private apiUrlActividades = `${environment.apiUrl}/api/ordenes-mantenimiento/actividades`;

  constructor(
    private http: HttpClient
  ) {}

  /**
   * Obtener todas las órdenes de mantenimiento
   */
getAll(): Observable<RespuestaOrdenesMantenimiento> {
  return this.http.get<RespuestaOrdenesMantenimiento>(
    this.apiUrl,
    { withCredentials: true }
  );
}

  /**
   * Obtener orden por ID
   */
  getById(
    id: number
  ): Observable<OrdenMantenimiento> {

    return this.http
      .get<ApiResponse<OrdenMantenimiento>>(
        `${this.apiUrl}/${id}`,
        {
          withCredentials: true
        }
      )
      .pipe(
        map(response => response.data)
      );
  }

  /**
   * Crear orden de mantenimiento
   */
  create(
    data: OrdenMantenimientoCreate
  ): Observable<OrdenMantenimiento> {

    return this.http
      .post<ApiResponse<OrdenMantenimiento>>(
        this.apiUrl,
        data,
        {
          withCredentials: true
        }
      )
      .pipe(
        map(response => response.data)
      );
  }

  /**
   * Actualizar orden
   */
  update(
    id: number,
    data: OrdenMantenimientoUpdate
  ): Observable<OrdenMantenimiento> {

    return this.http
      .put<ApiResponse<OrdenMantenimiento>>(
        `${this.apiUrl}/${id}`,
        data,
        {
          withCredentials: true
        }
      )
      .pipe(
        map(response => response.data)
      );
  }

  /**
   * Eliminar / cancelar orden
   */
  delete(
    id: number
  ): Observable<void> {

    return this.http
      .delete<void>(
        `${this.apiUrl}/${id}`,
        {
          withCredentials: true
        }
      );
  }


  /**
   * LISTADO DE ACTIVIDADES DE ORDEN DE MANTENIMIENTO
   */
  getActividades(
    ordenId: number
  ): Observable<ActividadOrden[]> {

    return this.http
      .get<ApiResponse<ActividadOrden[]>>(
        `${this.apiUrlActividades}/${ordenId}`,
        {
          withCredentials: true
        }
      )
      .pipe(
        map(response => response.data)
      );
  }

  /**
   * Entregar orden de mantenimiento enviar el id
   */
gestionarOrden(orden: any, gestionId: number): Observable<any> {
  console.log('Orden enviada:', orden);
  console.log('ID enviado:', orden?.id);

  return this.http.put<any>(
    `${this.apiUrl}/gestion/${gestionId}`,
    orden,
    { withCredentials: true }
  );
}

finalizarOrdenYProgramaciones(id: number): Observable<any> {
  return this.http.put(
    `${this.apiUrl}/${id}/finalizar`,
    {},
    { withCredentials: true }
  );
}
}




export interface ResumenEstadoOrden {
  estado_id: number;
  codigo: string;
  descripcion: string;
  cantidad: number;
}

export interface RespuestaOrdenesMantenimiento {
  codigo: number;
  mensaje: string;
  data: OrdenMantenimiento[];
  resumenEstados: ResumenEstadoOrden[];
}



export interface ServicioRealizado {
  id: number;
  tipo_de_mantenimiento: string;
}

export interface ActividadOrden {
  id: number;
  orden_mantenimiento_id: number;
  programacion_mantenimiento_id: number;
  plan_mantenimiento_actividad_id: number;
  actividad_id: number;
  estado_id: number;
  fecha_inicio: string | null;
  fecha_finalizacion: string | null;
  kilometraje_ejecucion: number | null;
  diagnostico: string | null;
  trabajo_realizado: string | null;
  observaciones: string | null;
  requiere_seguimiento: boolean;
  usuario_ejecucion_id: number | null;
  createdAt: string;
  updatedAt: string;

  servicioRealizado: ServicioRealizado | null;
}

